import cx from "classnames";
import React, { Fragment } from "react";

import {
  CTA_BUTTON_URL,
  HORIZONTAL_BAR,
  MAIN_ATTRIBUTE_URL,
  MAX_PLACEHOLDER_BARS,
  PRODUCT_LOGO_URL
} from "./constants";
import { Styles, withStyles } from "./styles";

const attributesPlaceholderRange = [...Array(MAX_PLACEHOLDER_BARS).keys()];

export const BasePlaceholder: React.FC<Styles> = ({ classes }) => (
  <>
    <div className={cx(classes.headerContainer, classes.containerColumn)}>
      <div className={classes.infoContainer}>
        <img alt="" role="presentation" width="118" height="102" src={PRODUCT_LOGO_URL} />
        <img alt="" role="presentation" width="164" height="100" src={MAIN_ATTRIBUTE_URL} />
      </div>
      <div className={classes.buttonContainer}>
        <img alt="" role="presentation" width="194" height="48" src={CTA_BUTTON_URL} />
      </div>
    </div>
    <div className={cx(classes.attributesContainer, classes.containerColumn)}>
      <img alt="" role="presentation" width="100%" height="27" src={HORIZONTAL_BAR} />
      {attributesPlaceholderRange.map(index => (
        <Fragment key={index}>
          <img alt="" role="presentation" width="166" height="18" src={HORIZONTAL_BAR} />
          <img alt="" role="presentation" width="246" height="18" src={HORIZONTAL_BAR} />
        </Fragment>
      ))}
    </div>
  </>
);

export const Placeholder = withStyles(BasePlaceholder);
